@if (applicationStateService.bookConfig.bookPermissions.pageFavorite.view) {
    <sidebar-page-favorites-content></sidebar-page-favorites-content>
}
<h2>Kapitel</h2>
<ul>
    @for (chapter of chapters; track chapter) {
        <li>
            <sidebar-single-chapter-content [chapter]="chapter"></sidebar-single-chapter-content>
        </li>
    }
</ul>

@if (!chapters || chapters.length <= 0) {
    <p>Es sind keine Kapitel vorhanden</p>
}


